export enum TokenType {
    Cloud = "Cloud",
    Physical = "Physical"
}

export const TokenTypeUtil = {
    getStringValue: (tokenType: TokenType | null | undefined): string => {
        switch (tokenType) {
            case TokenType.Cloud:
                return "Облачный сертификат";
            case TokenType.Physical:
                return "Физический токен";
            default:
                return "";
        }
    }
};

